import { render, staticRenderFns } from "./GoToPayment.vue?vue&type=template&id=a5d574da&lang=pug&"
import script from "./GoToPayment.vue?vue&type=script&lang=ts&"
export * from "./GoToPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports